import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 0903A829-EB64-4B39-B066-FECF7908DA8A
 * name swap-vertical-bold
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/swap-vertical-bold.svg
 * tags
 * - Arrow 
 */
export const SwapVerticalBoldIcon = createSvgIcon(<><path d="M14,8H11V14H6V8H3L8.5,2L14,8M15.5,22L21,16H18V10H13V16H10L15.5,22Z" /></>, 'SwapVerticalBoldIcon');
export default SwapVerticalBoldIcon